import { render, staticRenderFns } from "./RuralDetails.vue?vue&type=template&id=724ba260&scoped=true&"
import script from "./RuralDetails.vue?vue&type=script&lang=js&"
export * from "./RuralDetails.vue?vue&type=script&lang=js&"
import style0 from "./RuralDetails.vue?vue&type=style&index=0&id=724ba260&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724ba260",
  null
  
)

export default component.exports